import React, { useMemo, useState } from "react";
import "./DataExporterFilters.less";
import { Button, Col, Collapse, DatePicker, Form, FormInstance, Input, Row, Select } from "antd";
import { ISearchFilterField } from "../../../lib/types";
import MultipleSelect from "../../common/MultipleSelect";
import { checkIsLoaded, checkIsLoading, displayFormat } from "../../../lib/utils";
import { useAppSelector } from "../../..";
import { BulkFiltersToggler } from "../../BulkFiltersToggler/BulkFiltersToggler";
import { AnyObject } from "../../../lib/interfaces";

const dateFormat = displayFormat;
const { RangePicker } = DatePicker;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

interface ComponentProps {
  form: FormInstance;
  defaultServicesSearchParams: AnyObject;
  onSearch: (values: AnyObject) => void;
  resetSearch: () => void;
  filtersCollapseState: string;
  setFiltersCollapsState: React.Dispatch<React.SetStateAction<string>>;
}

export const DataExporterFilters = (props: ComponentProps) => {
  const {
    resetSearch,
    filtersCollapseState,
    form,
    defaultServicesSearchParams,
    onSearch,
    setFiltersCollapsState,
  } = props;

  const { glsTypes, glsTypesLoading, glsStatuses, glsStatusesLoading } = useAppSelector(
    (state) => state.rtkDictionaries
  );

  const getPanelHeader = () =>
    filtersCollapseState === "unfolded" ? (
      ""
    ) : (
      <div className="bulk__panel_header">Показать фильтры</div>
    );

  const toggleFiltersCollapseState = () => {
    const newState = filtersCollapseState === "unfolded" ? "folded" : "unfolded";
    setFiltersCollapsState(newState);
  };

  const allFieldProducts: ISearchFilterField[] = useMemo(
    () => [
      {
        label: "Тип",
        fieldElement: (
          <Form.Item label="Тип" name="glsTypeIds">
            <MultipleSelect
              placeholder="Выбрать"
              showArrow
              allValues={glsTypes?.map(({ id }) => id) || []}
              maxTagCount={3}
              loading={checkIsLoading(glsTypesLoading)}
              allowClear
            >
              {checkIsLoaded(glsTypesLoading) &&
                glsTypes &&
                glsTypes.map(({ id, name }) => (
                  <Select.Option value={id} key={id}>
                    {name}
                  </Select.Option>
                ))}
            </MultipleSelect>
          </Form.Item>
        ),
        visible: true,
      },
      {
        label: "Статус",
        fieldElement: (
          <Form.Item label="Статус" name="glsStatusIds">
            <MultipleSelect
              placeholder="Выбрать"
              showArrow
              allValues={glsStatuses?.map(({ id }) => id) || []}
              maxTagCount={3}
              loading={checkIsLoading(glsStatusesLoading)}
              allowClear
            >
              {checkIsLoaded(glsStatusesLoading) &&
                glsStatuses &&
                glsStatuses.map(({ id, name }) => (
                  <Select.Option value={id} key={id}>
                    {name}
                  </Select.Option>
                ))}
            </MultipleSelect>
          </Form.Item>
        ),
        visible: true,
      },
      {
        label: "Дата",
        fieldElement: (
          <Form.Item dependencies={["period"]} noStyle>
            {({ getFieldValue }) => {
              const period = getFieldValue("period");
              return (
                <Form.Item label="Дата" name="onDate">
                  <DatePicker
                    disabled={!!period}
                    format={displayFormat}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        ),
        visible: true,
      },
      {
        label: "Период",
        fieldElement: (
          <Form.Item dependencies={["onDate"]} noStyle>
            {({ getFieldValue }) => {
              const onDate = getFieldValue("onDate");
              return (
                <Form.Item label="Период" name="period">
                  <RangePicker
                    disabled={!!onDate}
                    style={{ width: "100%" }}
                    format={dateFormat}
                    allowClear
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        ),
        visible: true,
      },
      {
        label: "ID процедур выгрузки",
        fieldElement: (
          <Form.Item
            label="ID процедур выгрузки"
            name="ids"
            className="form-item-required__hidden-error__mb0"
            rules={[
              {
                validator: (x, value) => {
                  if (value && /[^0-9,]/.test(value)) {
                    return Promise.reject();
                  }
                  return Promise.resolve();
                },
                message: "В качестве разделителя может использоваться только запятая",
              },
            ]}
          >
            <Input placeholder='Введите ID процедур выгрузки через ","' allowClear />
          </Form.Item>
        ),
        visible: false,
      },
    ],
    [glsTypes, glsTypesLoading, glsStatuses, glsStatusesLoading]
  );

  const [fields, setFields] = useState<ISearchFilterField[]>(allFieldProducts);

  return (
    <div className="dataExporter-searchFilters">
      <div className="inner-row">
        <Collapse
          defaultActiveKey="1"
          onChange={toggleFiltersCollapseState}
          expandIconPosition="right"
          className="filter-collapse"
        >
          <Collapse.Panel header={getPanelHeader()} key="1" className="dataExporter__panel">
            <Row justify="end">
              <BulkFiltersToggler
                allFields={allFieldProducts}
                setFields={setFields}
                filterName="dataExporter"
                minSave={["Тип"]}
              />
            </Row>
            <Form
              form={form}
              labelAlign="left"
              initialValues={defaultServicesSearchParams}
              {...layout}
              onFinish={onSearch}
            >
              <Row gutter={50}>
                {fields
                  .filter(({ visible }) => visible)
                  .map(({ fieldElement }, idx) => (
                    <Col span={8} key={idx}>
                      {fieldElement}
                    </Col>
                  ))}
              </Row>
              <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "right", marginBottom: 0 }}>
                <Button onClick={resetSearch}>Сброс параметров</Button>
                <Button
                  // loading={checkIsLoading(servicesSearchingLoading)}
                  htmlType="submit"
                  type="primary"
                >
                  Применить
                </Button>
              </Form.Item>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </div>
    </div>
  );
};
